var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinimizeChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_811_6827",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#6A7282"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_811_6827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.95352 17.9168L2.08331 17.0466L7.87977 11.2502H3.74998V10.0002H9.99998V16.2502H8.74998V12.1204L2.95352 17.9168ZM9.99998 10.0002V3.75016H11.25V7.87995L17.0464 2.0835L17.9166 2.9537L12.1202 8.75016H16.25V10.0002H9.99998Z",
    fill: "#6A7282"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimizeChat);
export default __webpack_public_path__ + "static/media/minimizeChat.7fc2a584e54de8f3de4822bb32c97b26.svg";
export { ForwardRef as ReactComponent };